import { ChangeDetectorRef, Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import { Dialog, DialogModule } from 'primeng/dialog';
import { TextareaModule } from 'primeng/textarea';
import { EditorModule } from 'primeng/editor';
import { EditorSpellcheckDirective } from '../../shared/directives/editor-spellcheck.directive';
import { CommonModule } from '@angular/common';
import { LineItemOptionValueModel, ControlTypeModel, LineItemModel, TemplateSectionModel, TableDataTypeModel, LineItemTableColumnModel, TemplateModel, LineItemTableColumnOptionValueModel, DataType, ControlType, SectionChildItem, ReferenceImageModel, parseLineItemAdditionalInfo } from '../../models/template.model';
import { TextboxControlComponent } from '../skidchecksheet/components/controls/textbox-control.component';
import { TextareaControlComponent } from '../skidchecksheet/components/controls/textarea-control.component';
import { CheckboxControlComponent } from '../skidchecksheet/components/controls/checkbox-control.component';
import { SelectControlComponent } from '../skidchecksheet/components/controls/select-control.component';
import { DatepickerControlComponent } from '../skidchecksheet/components/controls/datepicker-control.component';
import { DatetimepickerControlComponent } from '../skidchecksheet/components/controls/datetimepicker-control.component';
import { TableControlComponent } from '../skidchecksheet/components/controls/table-control.component';
import { AttachmentControlComponent } from '../skidchecksheet/components/controls/attachment-control.component';
import { PictureControlComponent } from '../skidchecksheet/components/controls/picture-control.component';
import { SignatureControlComponent } from '../skidchecksheet/components/controls/signature-control.component';
import { DigitalsignatureControlComponent } from '../skidchecksheet/components/controls/digitalsignature-control.component';
import { QrscannerControlComponent } from '../skidchecksheet/components/controls/qrscanner-control.component';
import { WeatherControlComponent } from '../skidchecksheet/components/controls/weather-control.component';
import { RichtextControlComponent } from '../skidchecksheet/components/controls/richtext-control.component';
import { LabeltextControlComponent } from '../skidchecksheet/components/controls/labeltext-control.component';
import { SkidsControlComponent } from '../skidchecksheet/components/controls/skids-control.component';
import { DecimalControlComponent } from '../skidchecksheet/components/controls/decimal-control.component';
import { IntegerControlComponent } from '../skidchecksheet/components/controls/integer-control.component';
import { PanelModule } from 'primeng/panel';
import { TEMPLATE_TYPE } from '../../models/template.constants';
import { TemplateService } from '../../services/template.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CardModule } from 'primeng/card';
import { MessageService } from 'primeng/api';
import { FormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { AuthService } from '../../core/services/auth.service';
import { IntegrationService } from '../../services/integration.service';
import { IntegrationTemplateAssociationModel } from '../../models/integration.model';
import { firstValueFrom, forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

interface PendingReferenceImagePreview {
  fileName: string;
  objectUrl: string;
}

const IMPACTED_AREA_OPTIONS = ['Customer', 'Transformer', 'Factory', 'Integrator'] as const;

@Component({
  selector: 'app-checksheet',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ToastModule,
    ButtonModule,
    CheckboxModule,
    InputTextModule,
    TextareaModule,
    EditorModule,
    DynamicDialogModule,
    TableModule,
    DialogModule,
    ReactiveFormsModule,
    CardModule,
    MultiSelectModule,
    SelectModule,
    PanelModule,
    TextboxControlComponent,
    TextareaControlComponent,
    CheckboxControlComponent,
    SelectControlComponent,
    DatepickerControlComponent,
    DatetimepickerControlComponent,
    TableControlComponent,
    AttachmentControlComponent,
    PictureControlComponent,
    SignatureControlComponent,
    DigitalsignatureControlComponent,
    QrscannerControlComponent,
    WeatherControlComponent,
    RichtextControlComponent,
    LabeltextControlComponent,
    SkidsControlComponent,
    DecimalControlComponent,
    IntegerControlComponent,
    EditorSpellcheckDirective
  ],
  templateUrl: './checksheet.html',
  styleUrl: './checksheet.css',
})
export class ChecksheetComponent implements OnInit {
  // Expose ControlType enum to template
  ControlType = ControlType;

  @ViewChild('lineItemDialog') lineItemDialog!: Dialog;
  @Input() templateId: number | null = null;
  subTemplateList: TemplateModel[] = [];
  selectedTemplateIds: number[] = [];
  sections: TemplateSectionModel[] = [];
  form!: FormGroup;
  showSectionDialog = false;
  showImportTemplateDialog = false;
  showPreviewDialog = false;
  isGeneratingPdf = false;
  previewValues: { [lineItemId: number]: any } = {};

  getPreviewValue(lineItemId: number | undefined): any {
    if (lineItemId === undefined) return undefined;
    return this.previewValues[lineItemId];
  }

  setPreviewValue(lineItemId: number | undefined, value: any): void {
    if (lineItemId === undefined) return;
    this.previewValues[lineItemId] = value;
  }
  isEdit = false;
  selectedSection: TemplateSectionModel | null = null;
  hideImportTemplateButton = false;
  currentParentSectionId: number | null = null; // For subsection creation
  currentImportParentSectionId: number | null = null; // For import as subsection

  template: TemplateModel = {} as TemplateModel;
  // Checklist state
  showChecklistDialog = false;
  lineItemSectionId: number | null = null;
  lineItemForm!: FormGroup;
  isLineItemEdit = false;
  selectedLineItem: LineItemModel | null = null;
  controlTypeOptions: ControlTypeModel[] = [];
  tableDataTypeOptions: TableDataTypeModel[] = [];

  optionText: string = '';
  itemOptionValueList: LineItemOptionValueModel[] = [];
  referenceImages: ReferenceImageModel[] = [];
  pendingReferenceImageFiles: File[] = [];
  pendingReferenceImagePreviews: PendingReferenceImagePreview[] = [];
  columnText: string = '';
  selectedDataTypeId: number | null = 1;
  selectedColumnIntegrationMappingId: number | null = null;
  columnIsRequired: boolean = false;
  lineItemTableColumnList: LineItemTableColumnModel[] = [];
  columnOptionText: string = '';
  columnOptionValueList: LineItemTableColumnOptionValueModel[] = [];
  showColumnOptionsInput = false;
  editingTableColumn: LineItemTableColumnModel | null = null;
  integrationAssociations: IntegrationTemplateAssociationModel[] = [];
  integrationAssociationsByCategory: Record<string, IntegrationTemplateAssociationModel[]> = {};
  integrationCategoryOptions: { label: string; value: string }[] = [];
  selectedIntegrationCategory: string | null = null;
  private lineItemMappingByCategory: Record<string, number> = {};
  private columnMappingByCategory: Record<string, number> = {};
  private lastSelectedIntegrationCategory: string | null = null;
  loadingIntegrationAssociations = false;

  // Getter to check if we should show column options input
  get shouldShowColumnOptions(): boolean {
    const selectedId = Number(this.selectedDataTypeId);
    const isSelect = selectedId === DataType.Select || selectedId === 7;
    console.log('shouldShowColumnOptions - selectedDataTypeId:', this.selectedDataTypeId, 'selectedId:', selectedId, 'isSelect:', isSelect);
    return isSelect;
  }
  constructor(private fb: FormBuilder,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private messageService: MessageService,
    private templateService: TemplateService,
    private integrationService: IntegrationService,
    private authservice: AuthService,
    private router: Router) {
    this.initForm({} as TemplateSectionModel);
    this.initLineItemForm({} as LineItemModel);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.templateId = +params['templateId'] || 1;

      console.log('Template ID from URL:', this.templateId);

      this.getTemplate();
      this.loadSections();
      this.loadIntegrationAssociations();
    });

    // Check if coming from template/templatepagelist routes
    this.route.queryParams.subscribe(params => {
      const source = params['source'];
      this.hideImportTemplateButton = source === 'templates';
    });
    console.log('Hide Import Template Button:', this.hideImportTemplateButton);
    this.loadControlTypes();
    this.loadTableDataTypes();
  }

  onAllTemplates() {
    // In global templates context
    this.router.navigate(['/templates']);
  }

  initForm(item: TemplateSectionModel) {
    this.form = this.fb.group({
      templateId: [this.templateId],
      sectionId: [item.sectionId || null],
      sectionName: [item.sectionName || '', Validators.required],
      description: [item.description || ''],
      parentSectionId: [item.parentSectionId || null],
      lineItemList: [item.lineItemList || []],
    });
  }

  getTemplateList() {
    this.templateService.getTemplateList(TEMPLATE_TYPE.GENERIC).subscribe(templates => {
      console.log(templates);
      this.subTemplateList = templates.filter(t => t.isActive);
      this.cdr.markForCheck();
    });
  }

  getTemplate(): void {
    if (this.templateId !== null) {
      this.templateService.getTemplateById(this.templateId).subscribe(template => {
        console.log(template);
        this.template = template;
        this.cdr.markForCheck();
      });
    }
  }

  loadSections() {
    if (this.templateId !== null) {
      this.templateService.getTemplateSectionList(this.templateId).subscribe(sections => {
        console.log('Loaded sections:', sections);
        // Build hierarchical structure
        this.sections = this.buildHierarchy(sections);
        // Sort line items within each section by sortOrder
        this.sortLineItems(this.sections);
        this.cdr.markForCheck();
      });
    }
  }

  /**
   * Build hierarchical structure from flat section list
   * Top-level sections have parentSectionId = null
   */
  private buildHierarchy(flatSections: TemplateSectionModel[]): TemplateSectionModel[] {
    const sectionMap = new Map<number, TemplateSectionModel>();
    const rootSections: TemplateSectionModel[] = [];

    // First pass: Create map of all sections
    flatSections.forEach(section => {
      sectionMap.set(section.sectionId!, { ...section, subsections: [], isExpanded: false });
    });

    // Second pass: Build parent-child relationships
    flatSections.forEach(section => {
      const sectionNode = sectionMap.get(section.sectionId!);
      if (sectionNode) {
        if (section.parentSectionId === null || section.parentSectionId === undefined) {
          // Root level section
          rootSections.push(sectionNode);
        } else {
          // Child section - add to parent's subsections
          const parent = sectionMap.get(section.parentSectionId);
          if (parent) {
            parent.subsections = parent.subsections || [];
            parent.subsections.push(sectionNode);
          } else {
            // Parent not found, treat as root
            rootSections.push(sectionNode);
          }
        }
      }
    });

    // Sort sections by sortOrder
    this.sortSections(rootSections);
    return rootSections;
  }

  /**
   * Recursively sort sections and their subsections by sortOrder
   */
  private sortSections(sections: TemplateSectionModel[]): void {
    sections.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
    sections.forEach(section => {
      if (section.subsections && section.subsections.length > 0) {
        this.sortSections(section.subsections);
      }
    });
  }

  /**
   * Recursively find a section by ID in the hierarchy
   */
  private findSectionById(sectionId: number | undefined, sections: TemplateSectionModel[]): TemplateSectionModel | null {
    if (!sectionId) return null;

    for (const section of sections) {
      if (section.sectionId === sectionId) {
        return section;
      }
      if (section.subsections && section.subsections.length > 0) {
        const found = this.findSectionById(sectionId, section.subsections);
        if (found) return found;
      }
    }
    return null;
  }

  /**
   * Recursively sort line items within all sections by sortOrder
   */
  private sortLineItems(sections: TemplateSectionModel[]): void {
    sections.forEach(section => {
      if (section.lineItemList && section.lineItemList.length > 0) {
        section.lineItemList.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
      }
      if (section.subsections && section.subsections.length > 0) {
        this.sortLineItems(section.subsections);
      }
    });
  }

  /**
   * Get combined children (line items + subsections) sorted by sortOrder
   * This allows rendering items in the order they were added
   */
  getSectionChildren(section: TemplateSectionModel): SectionChildItem[] {
    const children: SectionChildItem[] = [];

    // Add line items
    if (section.lineItemList) {
      section.lineItemList.forEach(item => {
        children.push({
          type: 'lineItem',
          data: item,
          sortOrder: item.sortOrder || 0
        });
      });
    }

    // Add subsections
    if (section.subsections) {
      section.subsections.forEach(subsect => {
        children.push({
          type: 'subsection',
          data: subsect,
          sortOrder: subsect.sortOrder || 0
        });
      });
    }

    // Sort by sortOrder to maintain the order items were added
    children.sort((a, b) => a.sortOrder - b.sortOrder);

    return children;
  }

  /**
   * Type guard helper - get line item data from child
   */
  asLineItem(child: SectionChildItem): LineItemModel {
    return child.data as LineItemModel;
  }

  /**
   * Type guard helper - get subsection data from child
   */
  asSubsection(child: SectionChildItem): TemplateSectionModel {
    return child.data as TemplateSectionModel;
  }

  /**
   * Get the next sortOrder for a section (max of all children + 1)
   * This ensures unified sortOrder across line items and subsections
   */
  private getNextSortOrder(section: TemplateSectionModel): number {
    let maxSortOrder = 0;

    if (section.lineItemList) {
      section.lineItemList.forEach(item => {
        if ((item.sortOrder || 0) > maxSortOrder) {
          maxSortOrder = item.sortOrder || 0;
        }
      });
    }

    if (section.subsections) {
      section.subsections.forEach(subsect => {
        if ((subsect.sortOrder || 0) > maxSortOrder) {
          maxSortOrder = subsect.sortOrder || 0;
        }
      });
    }

    return maxSortOrder + 1;
  }

  loadControlTypes() {
    this.templateService.getControlType().subscribe((data: ControlTypeModel[]) => {
      console.log(data);
      this.controlTypeOptions = data;
    });
  }

  loadTableDataTypes() {
    this.templateService.getTableDataType().subscribe((data: TableDataTypeModel[]) => {
      console.log(data);
      this.tableDataTypeOptions = data;
      console.log(this.tableDataTypeOptions);
    });
  }

  openSectionDialog() {
    this.isEdit = false;
    this.currentParentSectionId = null;
    this.initForm({} as TemplateSectionModel);
    this.showSectionDialog = true;
  }

  openSubsectionDialog(parentSection: TemplateSectionModel) {
    this.isEdit = false;
    this.currentParentSectionId = parentSection.sectionId || null;
    this.initForm({ parentSectionId: this.currentParentSectionId } as TemplateSectionModel);
    this.showSectionDialog = true;
  }

  openEditDialog(section: TemplateSectionModel) {
    this.isEdit = true;
    this.form.patchValue(section);
    this.showSectionDialog = true;
  }

  saveSection() {
    if (this.form.invalid) return;
    const section = this.form.value as TemplateSectionModel;
    console.log('Saving section:', section);
    if (this.isEdit && section.sectionId && section.sectionId > 0) {
      this.templateService.updateTemplateSection(section).subscribe(res => {
        if (res) {
          this.showSectionDialog = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Section updated successfully' });
          // Reload to rebuild hierarchy
          this.loadSections();
        }
      });
    } else {
      // Add - ensure parentSectionId is set if creating subsection
      if (this.currentParentSectionId) {
        section.parentSectionId = this.currentParentSectionId;
        // Set unified sortOrder for subsections
        const parentSection = this.findSectionById(this.currentParentSectionId, this.sections);
        if (parentSection) {
          section.sortOrder = this.getNextSortOrder(parentSection);
        }
      }
      this.templateService.addTemplateSection(section).subscribe(res => {
        if (res) {
          console.log('Added section with ID:', res);
          section.sectionId = res;
          this.showSectionDialog = false;
          const message = section.parentSectionId
            ? 'Subsection added successfully'
            : 'Section added successfully';
          this.messageService.add({ severity: 'success', summary: 'Success', detail: message });
          // Reload to rebuild hierarchy
          this.loadSections();
          this.currentParentSectionId = null;
        }
      });
    }
  }

  deleteSection(section: TemplateSectionModel) {
    if (section.sectionId && confirm('Delete this section?')) {
      this.templateService.deleteTemplateSection(section.sectionId).subscribe(res => {
        if (res) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Section deleted successfully' });
          this.loadSections();
        }
      });
    }
  }

  // Line Item logic

  initLineItemForm(item: LineItemModel) {
    this.lineItemForm = this.fb.group({
      lineItemId: [item.lineItemId || null],
      sectionId: [item.sectionId || this.lineItemSectionId || null],
      name: [item.name || '', Validators.required],
      controlTypeId: [item.controlTypeId || 1, Validators.required],
      integrationMappingId: [item.integrationMappingId ?? null],
      isRequired: [item.isRequired || false],
      defaultText: [item.defaultText || ''],
      lineItemOptionValueList: [item.lineItemOptionValueList || []],
      lineItemTableColumnList: [item.lineItemTableColumnList || []],
      // Validation config fields (serialized to JSON on save)
      vcMinLength: [null],
      vcMaxLength: [null],
      vcPattern: [null],
      vcPatternMessage: [null],
      vcMin: [null],
      vcMax: [null],
      vcMinCount: [null],
      vcMaxCount: [null],
      vcMinSelections: [null],
      vcMaxSelections: [null],
      vcMinDate: [null],
      vcMaxDate: [null],
      vcMinRows: [null],
      vcMaxRows: [null],
    });
    this.parseValidationConfigToForm(item.validationConfig);
    this.lineItemForm.get('controlTypeId')?.valueChanges.subscribe(() => this.onControlTypeChanged());
    this.onControlTypeChanged();
  }

  private parseValidationConfigToForm(validationConfig: string | null | undefined): void {
    if (!validationConfig) return;
    try {
      const config = JSON.parse(validationConfig);
      if (typeof config !== 'object' || config === null) return;
      const patch: any = {};
      if (config.minLength !== undefined) patch.vcMinLength = config.minLength;
      if (config.maxLength !== undefined) patch.vcMaxLength = config.maxLength;
      if (config.pattern !== undefined) patch.vcPattern = config.pattern;
      if (config.patternMessage !== undefined) patch.vcPatternMessage = config.patternMessage;
      if (config.min !== undefined) patch.vcMin = config.min;
      if (config.max !== undefined) patch.vcMax = config.max;
      if (config.minCount !== undefined) patch.vcMinCount = config.minCount;
      if (config.maxCount !== undefined) patch.vcMaxCount = config.maxCount;
      if (config.minSelections !== undefined) patch.vcMinSelections = config.minSelections;
      if (config.maxSelections !== undefined) patch.vcMaxSelections = config.maxSelections;
      if (config.minDate !== undefined) patch.vcMinDate = config.minDate;
      if (config.maxDate !== undefined) patch.vcMaxDate = config.maxDate;
      if (config.minRows !== undefined) patch.vcMinRows = config.minRows;
      if (config.maxRows !== undefined) patch.vcMaxRows = config.maxRows;
      this.lineItemForm.patchValue(patch);
    } catch {
      // Ignore malformed json
    }
  }

  private buildValidationConfigJson(controlTypeId: number | undefined): string | null {
    const ctId = Number(controlTypeId);
    const f = this.lineItemForm;
    const getNum = (name: string): number | undefined => {
      const v = f.get(name)?.value;
      return (v !== null && v !== undefined && v !== '') ? Number(v) : undefined;
    };
    const getStr = (name: string): string | undefined => {
      const v = f.get(name)?.value;
      return (v !== null && v !== undefined && v !== '') ? String(v) : undefined;
    };

    let config: any = null;

    if (ctId === ControlType.TextBox || ctId === ControlType.TextArea) {
      const minLength = getNum('vcMinLength');
      const maxLength = getNum('vcMaxLength');
      const pattern = getStr('vcPattern');
      const patternMessage = getStr('vcPatternMessage');
      if (minLength !== undefined || maxLength !== undefined || pattern) {
        config = { minLength, maxLength, pattern, patternMessage };
      }
    } else if (ctId === ControlType.Integer || ctId === ControlType.Decimal) {
      const min = getNum('vcMin');
      const max = getNum('vcMax');
      if (min !== undefined || max !== undefined) {
        config = { min, max };
      }
    } else if (ctId === ControlType.Picture || ctId === ControlType.Attachment || ctId === ControlType.Signature) {
      const minCount = getNum('vcMinCount');
      const maxCount = getNum('vcMaxCount');
      if (minCount !== undefined || maxCount !== undefined) {
        config = { minCount, maxCount };
      }
    } else if (ctId === ControlType.Select || ctId === ControlType.ImpactedArea) {
      const minSelections = getNum('vcMinSelections');
      const maxSelections = getNum('vcMaxSelections');
      if (minSelections !== undefined || maxSelections !== undefined) {
        config = { minSelections, maxSelections };
      }
    } else if (ctId === ControlType.DatePicker || ctId === ControlType.DateTimePicker) {
      const minDate = getStr('vcMinDate');
      const maxDate = getStr('vcMaxDate');
      if (minDate || maxDate) {
        config = { minDate, maxDate };
      }
    } else if (ctId === ControlType.Table) {
      const minRows = getNum('vcMinRows');
      const maxRows = getNum('vcMaxRows');
      if (minRows !== undefined || maxRows !== undefined) {
        config = { minRows, maxRows };
      }
    }

    if (config) {
      Object.keys(config).forEach((k) => config[k] === undefined && delete config[k]);
      return Object.keys(config).length > 0 ? JSON.stringify(config) : null;
    }
    return null;
  }

  openLineItemDialog(section: TemplateSectionModel) {
    console.log('Open line item for section:', section);
    this.lineItemSectionId = section.sectionId || null;
    this.isLineItemEdit = false;
    this.selectedLineItem = null;
    this.showChecklistDialog = true;
    this.initLineItemForm({ sectionId: this.lineItemSectionId } as LineItemModel);
    this.selectedIntegrationCategory = this.getValidCategory(this.selectedIntegrationCategory, this.integrationCategoryOptions);
    this.lastSelectedIntegrationCategory = this.selectedIntegrationCategory;
    this.lineItemMappingByCategory = {};
    this.columnMappingByCategory = {};

    this.resetColumnForm();
    this.optionText = '';
    this.itemOptionValueList = [];
    this.loadReferenceImages(null);
    this.ensureSelectedMappingsAreValid();
  }

  openEditLineItem(item: LineItemModel) {
    console.log('Edit line item:', item);
    this.isLineItemEdit = true;
    this.showChecklistDialog = true;
    this.initLineItemForm(item);
    this.selectedLineItem = item;
    this.optionText = '';
    // Filter out deleted options for display (form still has all options including deleted)
    this.itemOptionValueList = (item.lineItemOptionValueList || []).filter(opt => !opt.isDeleted);
    this.loadReferenceImages(item);
    this.columnText = '';
    this.columnIsRequired = false;
    this.lineItemTableColumnList = item.lineItemTableColumnList || [];
    
    // Reset column options
    this.columnOptionText = '';
    this.columnOptionValueList = [];
    this.showColumnOptionsInput = false;
    this.lineItemMappingByCategory = {};
    this.columnMappingByCategory = {};
    (item.integrationMappings || []).forEach((m) => {
      const type = (m.integrationType || '').toUpperCase();
      const id = this.normalizeIntegrationMappingId(m.integrationMappingId);
      if (type && id) {
        this.lineItemMappingByCategory[type] = id;
      }
    });

    const mappedCategory = this.findCategoryByMappingId(this.normalizeIntegrationMappingId(item.integrationMappingId));
    this.selectedIntegrationCategory = this.getValidCategory(mappedCategory ?? this.selectedIntegrationCategory, this.integrationCategoryOptions);
    const mappingId = this.normalizeIntegrationMappingId(item.integrationMappingId);
    if (mappedCategory && mappingId) {
      this.lineItemMappingByCategory[mappedCategory] = mappingId;
    }
    this.lastSelectedIntegrationCategory = this.selectedIntegrationCategory;
    this.ensureSelectedMappingsAreValid();
    this.enforceImpactedAreaOptions();
  }

  async saveLineItem() {
    if (this.lineItemForm.invalid) return;
    this.enforceImpactedAreaOptions();
    const item = this.lineItemForm.value as LineItemModel;
    item.validationConfig = this.buildValidationConfigJson(item.controlTypeId);
    this.rememberCurrentSelections(this.selectedIntegrationCategory);
    item.selectedIntegrationType = this.selectedIntegrationCategory;
    item.integrationMappings = this.buildIntegrationMappingsPayload(this.lineItemMappingByCategory);
    item.integrationMappingId = this.normalizeIntegrationMappingId(item.integrationMappingId);
    if (Number(item.controlTypeId) === 5) {
      item.integrationMappingId = null;
    }
    try {
      item.additionalInfo = await this.buildAdditionalInfo(item.controlTypeId);
    } catch (error) {
      console.error('Error uploading reference images:', error);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to upload reference images.' });
      return;
    }
    console.log('Saving line item:', item);
    if (this.isLineItemEdit && item.lineItemId && item.lineItemId > 0) {
      this.templateService.updateLineItem(item).subscribe(res => {
        if (res) {
          const section = this.findSectionById(item.sectionId, this.sections);
          if (section) {
            if (!section.lineItemList) section.lineItemList = [];

            // Update existing item
            const checklistIdx = section.lineItemList.findIndex((c: LineItemModel) => c.lineItemId === item.lineItemId);
            if (checklistIdx > -1) {
              const existingItem = section.lineItemList[checklistIdx];
              section.lineItemList[checklistIdx] = {
                ...existingItem,
                ...item,
                sortOrder: item.sortOrder ?? existingItem.sortOrder
              };
            }
          }
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Checklist item updated successfully' });
          
          // Reset form and properties after successful save
          this.resetLineItemForm();
        }
        this.cdr.markForCheck();
        this.showChecklistDialog = false;
      });
    } else {
      // Set unified sortOrder before adding
      const section = this.findSectionById(item.sectionId, this.sections);
      if (section) {
        item.sortOrder = this.getNextSortOrder(section);
      }

      this.templateService.addLineItem(item).subscribe(res => {
        if (res) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Checklist item added successfully' });
          item.lineItemId = res;
          console.log('Sections:', this.sections)
          const section = this.findSectionById(item.sectionId, this.sections);
          console.log('Section found for new item:', section);
          if (section) {
            if (!section.lineItemList) section.lineItemList = [];
            section.lineItemList.push({ ...item });
            console.log('Updated section line items:', section.lineItemList);
          }

          // Reset form and properties after successful save
          this.resetLineItemForm();
          this.showChecklistDialog = false;
        }
        this.cdr.markForCheck();
      });
    }

  }

  getIntegrationAssociationLabel(item: IntegrationTemplateAssociationModel): string {
    const source = item.sourceId?.trim();
    return source ? `${source} - ${item.kanseiId}` : `${item.kanseiId}`;
  }

  get filteredIntegrationAssociations(): IntegrationTemplateAssociationModel[] {
    if (!this.selectedIntegrationCategory) {
      return [];
    }
    return this.integrationAssociationsByCategory[this.selectedIntegrationCategory] || [];
  }

  get integrationOptionLabel(): string {
    return this.selectedIntegrationCategory === 'COMMON_TAGS' || this.selectedIntegrationCategory === 'DASHBOARD'
      ? 'kanseiId'
      : 'sourceId';
  }

  get integrationFilterBy(): string {
    return this.selectedIntegrationCategory === 'COMMON_TAGS' || this.selectedIntegrationCategory === 'DASHBOARD'
      ? 'kanseiId'
      : 'sourceId,kanseiId';
  }

  getIntegrationAssociationLabelById(mappingId: number | null | undefined): string {
    if (!mappingId) return 'None';
    const mapping = this.integrationAssociations.find(x => x.integrationMappingId === mappingId);
    return mapping ? this.getIntegrationAssociationLabel(mapping) : `Mapping #${mappingId}`;
  }

  onIntegrationCategoryChange(): void {
    this.rememberCurrentSelections(this.lastSelectedIntegrationCategory);
    this.applyCategorySelections(this.selectedIntegrationCategory);
    this.lastSelectedIntegrationCategory = this.selectedIntegrationCategory;
  }

  onColumnIntegrationMappingChange(): void {
    this.syncSelectedColumnMapping(this.selectedIntegrationCategory);
  }

  private normalizeIntegrationMappingId(value: number | string | null | undefined): number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }

  private loadIntegrationAssociations() {
    if (!this.templateId || this.templateId <= 0) {
      this.integrationAssociations = [];
      this.integrationAssociationsByCategory = {};
      this.integrationCategoryOptions = [];
      this.selectedIntegrationCategory = null;
      return;
    }

    this.loadingIntegrationAssociations = true;
    forkJoin({
      associations: this.integrationService.getTemplateAssociations(this.templateId).pipe(
        catchError(() => of([] as IntegrationTemplateAssociationModel[]))
      ),
      kisha: this.integrationService.getIntegrationMappings('KISHA').pipe(catchError(() => of([] as any[]))),
      ewmr: this.integrationService.getIntegrationMappings('EWMR').pipe(catchError(() => of([] as any[]))),
      commonTags: this.integrationService.getIntegrationMappings('COMMON_TAGS').pipe(catchError(() => of([] as any[]))),
      dashboard: this.integrationService.getIntegrationMappings('DASHBOARD').pipe(catchError(() => of([] as any[])))
    }).subscribe({
      next: ({ associations, kisha, ewmr, commonTags, dashboard }) => {
        this.integrationAssociations = associations || [];

        const kishaIds = new Set((kisha || []).map((x: any) => Number(x.integrationId)).filter((x: number) => Number.isFinite(x) && x > 0));
        const ewmrIds = new Set((ewmr || []).map((x: any) => Number(x.integrationId)).filter((x: number) => Number.isFinite(x) && x > 0));
        const commonTagIds = new Set((commonTags || []).map((x: any) => Number(x.integrationId)).filter((x: number) => Number.isFinite(x) && x > 0));
        const dashboardIds = new Set((dashboard || []).map((x: any) => Number(x.integrationId)).filter((x: number) => Number.isFinite(x) && x > 0));

        const byCategory: Record<string, IntegrationTemplateAssociationModel[]> = {
          KISHA: [],
          EWMR: [],
          COMMON_TAGS: [],
          DASHBOARD: []
        };

        this.integrationAssociations.forEach((item) => {
          const id = Number(item.integrationMappingId);
          if (!Number.isFinite(id) || id <= 0) return;
          if (kishaIds.has(id)) {
            byCategory['KISHA'].push(item);
          } else if (ewmrIds.has(id)) {
            byCategory['EWMR'].push(item);
          } else if (dashboardIds.has(id)) {
            byCategory['DASHBOARD'].push(item);
          } else if (commonTagIds.has(id)) {
            byCategory['COMMON_TAGS'].push(item);
          }
        });

        this.integrationAssociationsByCategory = byCategory;
        this.integrationCategoryOptions = this.getAvailableCategoryOptions(byCategory);
        this.selectedIntegrationCategory = this.getValidCategory(this.selectedIntegrationCategory, this.integrationCategoryOptions);
        this.ensureSelectedMappingsAreValid();
        this.loadingIntegrationAssociations = false;
        this.cdr.markForCheck();
      },
      error: (error) => {
        console.error('Error loading integration associations:', error);
        this.integrationAssociations = [];
        this.integrationAssociationsByCategory = {};
        this.integrationCategoryOptions = [];
        this.selectedIntegrationCategory = null;
        this.loadingIntegrationAssociations = false;
      }
    });
  }

  private getAvailableCategoryOptions(byCategory: Record<string, IntegrationTemplateAssociationModel[]>): { label: string; value: string }[] {
    const ordered = [
      { label: 'Kisha', value: 'KISHA' },
      { label: 'EWMR', value: 'EWMR' },
      { label: 'Common Tags', value: 'COMMON_TAGS' },
      { label: 'Dashboard', value: 'DASHBOARD' }
    ];
    return ordered.filter(opt => (byCategory[opt.value]?.length || 0) > 0);
  }

  private getValidCategory(current: string | null, options: { label: string; value: string }[]): string | null {
    if (current && options.some(x => x.value === current)) {
      return current;
    }
    return options.length > 0 ? options[0].value : null;
  }

  private findCategoryByMappingId(mappingId: number | null | undefined): string | null {
    if (!mappingId) {
      return null;
    }
    const id = Number(mappingId);
    if (!Number.isFinite(id) || id <= 0) {
      return null;
    }
    const categories = ['KISHA', 'EWMR', 'COMMON_TAGS', 'DASHBOARD'];
    for (const category of categories) {
      if ((this.integrationAssociationsByCategory[category] || []).some(x => x.integrationMappingId === id)) {
        return category;
      }
    }
    return null;
  }

  private ensureSelectedMappingsAreValid(): void {
    const allowedIds = new Set(this.filteredIntegrationAssociations.map(x => x.integrationMappingId));

    const lineItemMappingId = this.normalizeIntegrationMappingId(this.lineItemForm?.get('integrationMappingId')?.value);
    if (lineItemMappingId && !allowedIds.has(lineItemMappingId)) {
      this.lineItemForm?.get('integrationMappingId')?.setValue(null);
    }

    if (this.selectedColumnIntegrationMappingId && !allowedIds.has(this.selectedColumnIntegrationMappingId)) {
      this.selectedColumnIntegrationMappingId = null;
    }
  }

  private rememberCurrentSelections(category: string | null): void {
    if (!category) {
      return;
    }
    const lineItemMappingId = this.normalizeIntegrationMappingId(this.lineItemForm?.get('integrationMappingId')?.value);
    if (lineItemMappingId) {
      this.lineItemMappingByCategory[category] = lineItemMappingId;
    }
    const columnMappingId = this.normalizeIntegrationMappingId(this.selectedColumnIntegrationMappingId);
    if (columnMappingId) {
      this.columnMappingByCategory[category] = columnMappingId;
    }
  }

  private syncSelectedColumnMapping(category: string | null): void {
    if (!category) {
      return;
    }

    const columnMappingId = this.normalizeIntegrationMappingId(this.selectedColumnIntegrationMappingId);
    if (columnMappingId) {
      this.columnMappingByCategory[category] = columnMappingId;
    } else {
      delete this.columnMappingByCategory[category];
    }
  }

  private applyCategorySelections(category: string | null): void {
    if (!category) {
      this.lineItemForm?.get('integrationMappingId')?.setValue(null);
      this.selectedColumnIntegrationMappingId = null;
      return;
    }

    const allowedIds = new Set((this.integrationAssociationsByCategory[category] || []).map(x => x.integrationMappingId));

    const lineItemCandidate = this.lineItemMappingByCategory[category];
    this.lineItemForm?.get('integrationMappingId')?.setValue(
      lineItemCandidate && allowedIds.has(lineItemCandidate) ? lineItemCandidate : null
    );

    const columnCandidate = this.columnMappingByCategory[category];
    this.selectedColumnIntegrationMappingId =
      columnCandidate && allowedIds.has(columnCandidate) ? columnCandidate : null;
  }

  private buildIntegrationMappingsPayload(mappingByCategory: Record<string, number>): { integrationType: string; integrationMappingId: number }[] {
    return Object.entries(mappingByCategory)
      .filter(([_, id]) => Number.isFinite(id) && id > 0)
      .map(([integrationType, integrationMappingId]) => ({ integrationType, integrationMappingId }));
  }

  deleteLineItem(item: LineItemModel) {
    if (item.lineItemId && confirm('Delete this line item?')) {
      this.templateService.deleteLineItem(item.lineItemId).subscribe(res => {
        if (res) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Line item deleted successfully' });
          const section = this.findSectionById(item.sectionId, this.sections);
          if (section) {
            section.lineItemList = section.lineItemList?.filter((c: LineItemModel) => c.lineItemId !== item.lineItemId);
          }
          this.cdr.markForCheck();
        }
      });
    }
  }

  addOptionText() {
    if (this.isImpactedAreaControlType(this.lineItemForm.get('controlTypeId')?.value)) {
      return;
    }
    const option = this.optionText.trim();
    if (option) {
      const currentList = this.lineItemForm.get('lineItemOptionValueList')?.value as LineItemOptionValueModel[];
      const newOption: LineItemOptionValueModel = {
        lineItemId: this.lineItemForm.get('lineItemId')?.value || 0,
        valueText: option
      };
      currentList.push(newOption);
      this.lineItemForm.get('lineItemOptionValueList')?.setValue(currentList);
      // Filter out deleted items for display
      this.itemOptionValueList = currentList.filter(opt => !opt.isDeleted);
      this.optionText = '';
    }
  }

  onReferenceImagesSelected(event: Event) {
    const input = event.target as HTMLInputElement | null;
    const files = Array.from(input?.files || []);
    if (input) {
      input.value = '';
    }

    if (files.length === 0) {
      return;
    }

    const validFiles = files.filter(file =>
      file.type.startsWith('image/') || /\.(jpe?g|png|gif|webp|bmp|heic|heif)$/i.test(file.name)
    );

    if (validFiles.length !== files.length) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Only image files were added.' });
    }

    this.pendingReferenceImageFiles = [...this.pendingReferenceImageFiles, ...validFiles];
    this.pendingReferenceImagePreviews = [
      ...this.pendingReferenceImagePreviews,
      ...validFiles.map(file => ({
        fileName: file.name,
        objectUrl: URL.createObjectURL(file)
      }))
    ];
  }

  removeExistingReferenceImage(index: number) {
    this.referenceImages = this.referenceImages.filter((_, currentIndex) => currentIndex !== index);
  }

  removePendingReferenceImage(index: number) {
    const preview = this.pendingReferenceImagePreviews[index];
    if (preview?.objectUrl) {
      URL.revokeObjectURL(preview.objectUrl);
    }
    this.pendingReferenceImageFiles = this.pendingReferenceImageFiles.filter((_, currentIndex) => currentIndex !== index);
    this.pendingReferenceImagePreviews = this.pendingReferenceImagePreviews.filter((_, currentIndex) => currentIndex !== index);
  }

  getReferenceImageUrl(image: ReferenceImageModel): string {
    const path = image.thumbnailPath || image.filePath;
    return path ? this.templateService.getFileUrl(path) : '';
  }
  removeOptionText(index: number) {
    if (this.isImpactedAreaControlType(this.lineItemForm.get('controlTypeId')?.value)) {
      return;
    }
    const formList = this.lineItemForm.get('lineItemOptionValueList')?.value as LineItemOptionValueModel[];

    // Get active options for display (filter out already deleted ones)
    const activeOptions = formList.filter(opt => !opt.isDeleted);
    const optionToRemove = activeOptions[index];
    const actualIndex = formList.indexOf(optionToRemove);

    if (actualIndex !== -1) {
      // If option has optionValueId (exists in database), mark as deleted
      if (formList[actualIndex].optionValueId) {
        formList[actualIndex] = { ...formList[actualIndex], isDeleted: true };
      } else {
        // New option without ID - physically remove from array
        formList.splice(actualIndex, 1);
      }

      // Update form with full list (including deleted items)
      this.lineItemForm.get('lineItemOptionValueList')?.setValue(formList);

      // Update display list (filter out deleted items)
      this.itemOptionValueList = formList.filter(opt => !opt.isDeleted);
    }
  }

  getControlTypeName(controlTypeId: number): string {
    const numericId = Number(controlTypeId);
    const controlType = this.controlTypeOptions.find(ct => ct.controlTypeId === numericId);
    return controlType ? controlType.controlTypeName : 'Unknown';
  }
  getControlValueListText(controlValueList: any[]): string {
    if (!controlValueList || controlValueList.length === 0) {
      return 'N/A';
    }
    return controlValueList.map(item => item.valueText).join(', ');
  }

  getTableDataTypeName(dataTypeId: number): string {
    const dataType = this.tableDataTypeOptions.find(dt => dt.dataTypeId === dataTypeId);
    return dataType ? dataType.dataTypeName : 'Unknown';
  }
  getTableColumnListText(tableColumnList: any[]): string {
    if (!tableColumnList || tableColumnList.length === 0) {
      return 'N/A';
    }
    return tableColumnList.map(item => item.columnName).join(', ');
  }

  addTableColumn() {
    if (!this.editingTableColumn && this.getVisibleTableColumnCount() >= 9) {
      return;
    }
    const column = this.columnText.trim();
    if (column) {
      const currentList = this.lineItemForm.get('lineItemTableColumnList')?.value as LineItemTableColumnModel[];
      const dataTypeId = Number(this.selectedDataTypeId ?? 0) || 1;
      
      console.log('addTableColumn - dataTypeId:', dataTypeId, 'columnOptionValueList:', this.columnOptionValueList);
      
      // Create a copy of options before resetting the form
      const columnOptions = (dataTypeId === DataType.Select || dataTypeId === 7) ? [...this.columnOptionValueList] : undefined;
      this.syncSelectedColumnMapping(this.selectedIntegrationCategory);
      
      const newColumn: LineItemTableColumnModel = {
        lineItemId: this.lineItemForm.get('lineItemId')?.value || 0,
        dataTypeId: dataTypeId,
        columnName: column,
        integrationMappingId: this.normalizeIntegrationMappingId(this.selectedColumnIntegrationMappingId),
        selectedIntegrationType: this.selectedIntegrationCategory,
        integrationMappings: this.buildIntegrationMappingsPayload(this.columnMappingByCategory),
        isRequired: this.columnIsRequired,
        columnOptionValueList: columnOptions
      };

      console.log('newColumn created:', newColumn);

      if (this.editingTableColumn) {
        const editIndex = currentList.findIndex(c =>
          c === this.editingTableColumn ||
          (!!c.columnId && !!this.editingTableColumn?.columnId && c.columnId === this.editingTableColumn.columnId)
        );

        if (editIndex > -1) {
          currentList[editIndex] = {
            ...currentList[editIndex],
            ...newColumn
          };
        }
      } else {
        currentList.push(newColumn);
      }

      this.lineItemForm.get('lineItemTableColumnList')?.setValue(currentList);
      this.lineItemTableColumnList = currentList;

      // Reset form after creating the column
      this.resetColumnForm();
      console.log('Added table column:', currentList);
    }
  }

  editTableColumn(column: LineItemTableColumnModel) {
    this.columnMappingByCategory = {};
    (column.integrationMappings || []).forEach((m) => {
      const type = (m.integrationType || '').toUpperCase();
      const id = this.normalizeIntegrationMappingId(m.integrationMappingId);
      if (type && id) {
        this.columnMappingByCategory[type] = id;
      }
    });
    const mappedCategory = this.findCategoryByMappingId(this.normalizeIntegrationMappingId(column.integrationMappingId));
    this.selectedIntegrationCategory = this.getValidCategory(mappedCategory ?? this.selectedIntegrationCategory, this.integrationCategoryOptions);
    this.editingTableColumn = column;
    this.columnText = column.columnName || '';
    this.selectedDataTypeId = Number(column.dataTypeId ?? 1) || 1;
    this.selectedColumnIntegrationMappingId = this.normalizeIntegrationMappingId(column.integrationMappingId);
    if (this.selectedIntegrationCategory) {
      const selectedId = this.columnMappingByCategory[this.selectedIntegrationCategory];
      if (selectedId) {
        this.selectedColumnIntegrationMappingId = selectedId;
      }
    }
    const columnMappingId = this.normalizeIntegrationMappingId(column.integrationMappingId);
    if (mappedCategory && columnMappingId) {
      this.columnMappingByCategory[mappedCategory] = columnMappingId;
    }
    this.lastSelectedIntegrationCategory = this.selectedIntegrationCategory;
    this.columnIsRequired = !!column.isRequired;
    this.columnOptionValueList = (column.columnOptionValueList || []).map(opt => ({ ...opt }));
    this.showColumnOptionsInput = this.selectedDataTypeId === DataType.Select || this.selectedDataTypeId === 7;
  }

  onDataTypeChange() {
    console.log('onDataTypeChange called - selectedDataTypeId:', this.selectedDataTypeId);
    // Force update of showColumnOptionsInput
    setTimeout(() => {
      const selectedId = Number(this.selectedDataTypeId);
      this.showColumnOptionsInput = selectedId === DataType.Select || selectedId === 7;
      
      console.log('onDataTypeChange - selectedId:', selectedId, 'showColumnOptionsInput:', this.showColumnOptionsInput);
      
      if (!this.showColumnOptionsInput) {
        this.columnOptionValueList = [];
        this.columnOptionText = '';
      }
      
      // Force change detection
      this.cdr.detectChanges();
    }, 0);
  }

  addColumnOption() {
    const option = this.columnOptionText.trim();
    if (option && !this.columnOptionValueList.some(opt => opt.valueText === option)) {
      this.columnOptionValueList.push({
        valueText: option,
        sortOrder: this.columnOptionValueList.length + 1,
        isActive: true
      });
      this.columnOptionText = '';
    }
  }

  removeColumnOption(index: number) {
    this.columnOptionValueList.splice(index, 1);
    // Update sort order
    this.columnOptionValueList.forEach((opt, i) => opt.sortOrder = i + 1);
  }

  private resetColumnForm() {
    this.columnText = '';
    this.selectedColumnIntegrationMappingId = null;
    this.columnIsRequired = false;
    this.columnOptionValueList = [];
    this.columnOptionText = '';
    this.showColumnOptionsInput = false;
    this.selectedDataTypeId = 1;
    this.editingTableColumn = null;
  }

  private onControlTypeChanged(): void {
    if (this.isImpactedAreaControlType(this.lineItemForm.get('controlTypeId')?.value)) {
      this.enforceImpactedAreaOptions();
      this.optionText = '';
    }
  }

  private isImpactedAreaControlType(controlTypeId: unknown): boolean {
    return Number(controlTypeId) === ControlType.ImpactedArea;
  }

  private enforceImpactedAreaOptions(): void {
    if (!this.isImpactedAreaControlType(this.lineItemForm.get('controlTypeId')?.value)) {
      return;
    }

    const currentList = (this.lineItemForm.get('lineItemOptionValueList')?.value as LineItemOptionValueModel[]) || [];
    const fixedOptions: LineItemOptionValueModel[] = IMPACTED_AREA_OPTIONS.map((valueText) => {
      const existing = currentList.find(x => x.valueText?.trim().toLowerCase() === valueText.toLowerCase());
      return {
        optionValueId: existing?.optionValueId,
        lineItemId: this.lineItemForm.get('lineItemId')?.value || existing?.lineItemId || 0,
        valueText,
        isDeleted: false
      };
    });

    this.lineItemForm.get('lineItemOptionValueList')?.setValue(fixedOptions);
    this.itemOptionValueList = fixedOptions;
  }

  resetLineItemForm() {
    // Reset the form to initial state
    this.initLineItemForm({} as LineItemModel);
    
    // Reset component properties
    this.lineItemTableColumnList = [];
    this.itemOptionValueList = [];
    this.optionText = '';
    
    // Reset column-related properties
    this.resetColumnForm();
    this.selectedIntegrationCategory = this.getValidCategory(this.selectedIntegrationCategory, this.integrationCategoryOptions);
    this.lastSelectedIntegrationCategory = this.selectedIntegrationCategory;
    this.lineItemMappingByCategory = {};
    this.columnMappingByCategory = {};
    this.clearReferenceImagesState();
    
    // Reset edit state
    this.isLineItemEdit = false;
    this.selectedLineItem = null;
  }

  private loadReferenceImages(item: LineItemModel | null): void {
    this.clearReferenceImagesState();
    this.referenceImages = parseLineItemAdditionalInfo(item?.additionalInfo).referenceImages?.filter(image => !!image?.filePath) ?? [];
  }

  private clearReferenceImagesState(): void {
    this.pendingReferenceImagePreviews.forEach(preview => {
      if (preview.objectUrl) {
        URL.revokeObjectURL(preview.objectUrl);
      }
    });
    this.referenceImages = [];
    this.pendingReferenceImageFiles = [];
    this.pendingReferenceImagePreviews = [];
  }

  private async buildAdditionalInfo(controlTypeId: number | undefined): Promise<string | null> {
    if (Number(controlTypeId) !== ControlType.Picture) {
      return null;
    }

    let uploadedReferenceImages: ReferenceImageModel[] = [];
    if (this.pendingReferenceImageFiles.length > 0) {
      if (!this.templateId) {
        throw new Error('Template ID is required before uploading reference images.');
      }
      uploadedReferenceImages = await firstValueFrom(
        this.templateService.uploadReferenceImages(this.templateId, this.pendingReferenceImageFiles)
      );
    }

    const referenceImages = [...this.referenceImages, ...uploadedReferenceImages];
    return referenceImages.length > 0
      ? JSON.stringify({ referenceImages })
      : null;
  }
  getVisibleTableColumns(): LineItemTableColumnModel[] {
    return (this.lineItemTableColumnList || []).filter(col => !col.isDeleted);
  }

  getVisibleTableColumnCount(): number {
    return this.getVisibleTableColumns().length;
  }

  removeTableColumn(column: LineItemTableColumnModel) {
    const currentList = this.lineItemForm.get('lineItemTableColumnList')?.value as LineItemTableColumnModel[];
    if (!currentList?.length) {
      return;
    }

    if (this.editingTableColumn && (this.editingTableColumn === column
      || (!!this.editingTableColumn.columnId && !!column.columnId && this.editingTableColumn.columnId === column.columnId))) {
      this.resetColumnForm();
    }

    const targetIndex = currentList.findIndex(c =>
      c === column || (!!c.columnId && !!column.columnId && c.columnId === column.columnId)
    );

    if (targetIndex === -1) {
      return;
    }

    if (currentList[targetIndex].columnId && currentList[targetIndex].columnId > 0) {
      currentList[targetIndex] = { ...currentList[targetIndex], isDeleted: true };
    } else {
      currentList.splice(targetIndex, 1);
    }

    this.lineItemForm.get('lineItemTableColumnList')?.setValue(currentList);
    this.lineItemTableColumnList = currentList;
  }

  /**
   * Move child (line item or subsection) up in the unified list
   */
  moveChildUp(section: TemplateSectionModel, index: number) {
    const children = this.getSectionChildren(section);
    if (index === 0 || children.length < 2) return;

    // Physical swap in the unified array
    [children[index - 1], children[index]] = [children[index], children[index - 1]];

    // Assign sequential sortOrder values (1, 2, 3...) to all children
    children.forEach((child, idx) => {
      child.sortOrder = idx + 1;
      child.data.sortOrder = idx + 1;
    });

    // Write reordered items back to section arrays
    section.lineItemList = children.filter(c => c.type === 'lineItem').map(c => c.data as LineItemModel);
    section.subsections = children.filter(c => c.type === 'subsection').map(c => c.data as TemplateSectionModel);

    this.updateChildrenSortOrder(section);
  }

  /**
   * Move child (line item or subsection) down in the unified list
   */
  moveChildDown(section: TemplateSectionModel, index: number) {
    const children = this.getSectionChildren(section);
    if (index >= children.length - 1 || children.length < 2) return;

    // Physical swap in the unified array
    [children[index], children[index + 1]] = [children[index + 1], children[index]];

    // Assign sequential sortOrder values (1, 2, 3...) to all children
    children.forEach((child, idx) => {
      child.sortOrder = idx + 1;
      child.data.sortOrder = idx + 1;
    });

    // Write reordered items back to section arrays
    section.lineItemList = children.filter(c => c.type === 'lineItem').map(c => c.data as LineItemModel);
    section.subsections = children.filter(c => c.type === 'subsection').map(c => c.data as TemplateSectionModel);

    this.updateChildrenSortOrder(section);
  }

  /**
   * Update sortOrder for all children (line items and subsections) in a section
   * Calls both batch update APIs
   */
  private updateChildrenSortOrder(section: TemplateSectionModel) {
    const lineItemUpdates: { lineItemId: number; sortOrder: number; updatedBy: number }[] = [];
    const sectionUpdates: { sectionId: number; sortOrder: number; updatedBy: number }[] = [];
    const userId = this.authservice.getCurrentUser()?.userId || 0;

    // Collect line item updates
    if (section.lineItemList) {
      section.lineItemList.forEach(item => {
        lineItemUpdates.push({
          lineItemId: item.lineItemId,
          sortOrder: item.sortOrder || 0,
          updatedBy: userId
        });
      });
    }

    // Collect subsection updates
    if (section.subsections) {
      section.subsections.forEach(subsect => {
        sectionUpdates.push({
          sectionId: subsect.sectionId!,
          sortOrder: subsect.sortOrder || 0,
          updatedBy: userId
        });
      });
    }

    // Execute both updates
    let completedCount = 0;
    const totalUpdates = (lineItemUpdates.length > 0 ? 1 : 0) + (sectionUpdates.length > 0 ? 1 : 0);

    const onComplete = () => {
      completedCount++;
      if (completedCount === totalUpdates) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Order updated successfully'
        });
        this.cdr.markForCheck();
      }
    };

    const onError = (error: any) => {
      console.error('Error updating order:', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to update order'
      });
      this.loadSections();
    };

    if (lineItemUpdates.length > 0) {
      this.templateService.batchUpdateLineItemSortOrder(lineItemUpdates).subscribe({
        next: onComplete,
        error: onError
      });
    }

    if (sectionUpdates.length > 0) {
      this.templateService.batchUpdateTemplateSectionSortOrder(sectionUpdates).subscribe({
        next: onComplete,
        error: onError
      });
    }

    if (totalUpdates === 0) {
      this.cdr.markForCheck();
    }
  }

  /**
   * Move line item up in the list (legacy - kept for compatibility)
   */
  moveLineItemUp(section: TemplateSectionModel, item: LineItemModel, index: number) {
    if (!section.lineItemList || index === 0) return;

    // Swap with previous item
    const temp = section.lineItemList[index - 1];
    section.lineItemList[index - 1] = section.lineItemList[index];
    section.lineItemList[index] = temp;

    // Update sortOrder values
    this.updateLineItemSortOrder(section);
  }

  /**
   * Move line item down in the list (legacy - kept for compatibility)
   */
  moveLineItemDown(section: TemplateSectionModel, item: LineItemModel, index: number) {
    if (!section.lineItemList || index === section.lineItemList.length - 1) return;

    // Swap with next item
    const temp = section.lineItemList[index + 1];
    section.lineItemList[index + 1] = section.lineItemList[index];
    section.lineItemList[index] = temp;

    // Update sortOrder values
    this.updateLineItemSortOrder(section);
  }

  /**
   * Update sortOrder for all line items in a section and save to backend
   * Uses batch update to save all items in a single API call
   */
  private updateLineItemSortOrder(section: TemplateSectionModel) {
    if (!section.lineItemList) return;

    // Assign new sortOrder values (1, 2, 3, ...)
    section.lineItemList.forEach((item, idx) => {
      item.sortOrder = idx + 1;
    });

    // Prepare batch update payload with only necessary fields
    const sortOrderUpdates = section.lineItemList.map(item => ({
      lineItemId: item.lineItemId,
      sortOrder: item.sortOrder!,
      updatedBy: this.authservice.getCurrentUser()?.userId || 0
    }));

    // Single batch API call instead of multiple individual calls
    this.templateService.batchUpdateLineItemSortOrder(sortOrderUpdates).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Line item order updated successfully'
        });
        this.cdr.markForCheck();
      },
      error: (error) => {
        console.error('Error updating line item order:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update line item order'
        });
        // Reload to restore original order
        this.loadSections();
      }
    });
  }

  /**
   * Move section up in the list (only within siblings)
   */
  moveSectionUp(section: TemplateSectionModel, sections: TemplateSectionModel[], index: number) {
    if (!sections || sections.length < 2) return;
    if (index <= 0 || index >= sections.length) return;
    if (!sections[index] || !sections[index - 1]) return;

    // Swap with previous sibling
    const temp = sections[index - 1];
    sections[index - 1] = sections[index];
    sections[index] = temp;

    // Update sortOrder values for affected siblings
    this.updateSectionSortOrder(sections);
  }

  /**
   * Move section down in the list (only within siblings)
   */
  moveSectionDown(section: TemplateSectionModel, sections: TemplateSectionModel[], index: number) {
    if (!sections || sections.length < 2) return;
    if (index < 0 || index >= sections.length - 1) return;
    if (!sections[index] || !sections[index + 1]) return;

    // Swap with next sibling
    const temp = sections[index + 1];
    sections[index + 1] = sections[index];
    sections[index] = temp;

    // Update sortOrder values for affected siblings
    this.updateSectionSortOrder(sections);
  }

  /**
   * Update sortOrder for sections and save to backend
   * Uses batch update to save all sections in a single API call
   */
  private updateSectionSortOrder(sections: TemplateSectionModel[]) {
    if (!sections || sections.length === 0) return;
    const validSections = sections.filter((section): section is TemplateSectionModel => !!section);
    if (validSections.length === 0) return;
    if (validSections.length !== sections.length) {
      // Keep the source array clean in case an invalid entry slipped in.
      sections.splice(0, sections.length, ...validSections);
    }

    // Assign new sortOrder values (1, 2, 3, ...)
    validSections.forEach((section, idx) => {
      section.sortOrder = idx + 1;
    });

    // Prepare batch update payload with only necessary fields
    const sortOrderUpdates = validSections
      .filter(section => section.sectionId !== null && section.sectionId !== undefined)
      .map(section => ({
      sectionId: section.sectionId!,
      sortOrder: section.sortOrder!,
      updatedBy: this.authservice.getCurrentUser()?.userId || 0
    }));

    if (sortOrderUpdates.length === 0) return;

    // Single batch API call instead of multiple individual calls
    this.templateService.batchUpdateTemplateSectionSortOrder(sortOrderUpdates).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Section order updated successfully'
        });
        this.cdr.markForCheck();
      },
      error: (error) => {
        console.error('Error updating section order:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update section order'
        });
        // Reload to restore original order
        this.loadSections();
      }
    });
  }

  /**
   * Toggle section expanded/collapsed state
   */
  toggleSection(section: TemplateSectionModel) {
    section.isExpanded = !section.isExpanded;
    this.cdr.markForCheck();
  }

  /**
   * Find a section by ID (recursively searches through subsections)
   */
  private findSection(sections: TemplateSectionModel[], sectionId: number): TemplateSectionModel | null {
    for (const section of sections) {
      if (section.sectionId === sectionId) {
        return section;
      }
      if (section.subsections) {
        const found = this.findSection(section.subsections, sectionId);
        if (found) return found;
      }
    }
    return null;
  }

  openImportDialog() {
    this.currentImportParentSectionId = null; // Top-level import
    this.showImportTemplateDialog = true;
    this.getTemplateList();
  }

  openImportSubTemplateDialog(parentSection: TemplateSectionModel) {
    this.currentImportParentSectionId = parentSection.sectionId || null;
    this.showImportTemplateDialog = true;
    this.getTemplateList();
  }

  onImportComplete() {
    this.showImportTemplateDialog = false;
    this.templateService.importTemplates({
      templateId: this.templateId || 0,
      subtemplateIds: this.selectedTemplateIds,
      updatedBy: this.authservice.getCurrentUser()?.userId || 0,
      parentSectionId: this.currentImportParentSectionId
    }).subscribe(() => {
      const message = this.currentImportParentSectionId
        ? 'Sub-templates imported successfully as subsections'
        : 'Templates imported successfully';
      this.messageService.add({ severity: 'success', summary: 'Success', detail: message });
      this.loadSections();
      this.currentImportParentSectionId = null;
    });
  }

  /**
   * Download the template preview as PDF using backend Chromium rendering.
   */
  async downloadPdf(): Promise<void> {
    if (!this.templateId) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Template not found' });
      return;
    }

    this.isGeneratingPdf = true;

    try {
      const blob = await firstValueFrom(this.templateService.exportTemplatePreviewPdf(this.templateId));
      const fileName = this.template.templateName
        ? `${this.template.templateName}.pdf`
        : 'template-preview.pdf';
      this.triggerBlobDownload(blob, fileName);

      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PDF downloaded successfully' });
    } catch (error) {
      console.error('Error generating PDF:', error);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to generate PDF. Please try again.' });
    } finally {
      this.isGeneratingPdf = false;
    }
  }

  private triggerBlobDownload(blob: Blob, fileName: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

}
